import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RequestsServices } from './requests.service';
import { from } from 'rxjs';

@Injectable()
export class VouchersService {

  constructor(
    private request: RequestsServices
  ) {}

  getVouchers(): Observable<any> {
    return from(this.request.get({path: 'vouchers', endPoint: '/me'}));
  }

  generateVoucher(): Observable<any> {
    return from(this.request.get({path: 'invite_members', endPoint: '/generate-my-voucher'}));
  }

  canGenerate(): Observable<any> {
    return from(this.request.get({path: 'invite_members', endPoint: '/check-voucher-generate'}));
  }

  setVoucherView(ids: string[] = []): Observable<any> {
    return from(this.request.post('vouchers', {ids}, '/viewed'));
  }
}
